var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 29.5,
    height: 29.5,
    rx: 4.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1038 8.66848C20.3158 8.45654 20.5674 8.28843 20.8443 8.17373C21.1212 8.05903 21.418 8 21.7177 8C22.0174 8 22.3142 8.05903 22.5911 8.17373C22.868 8.28843 23.1196 8.45654 23.3315 8.66848C23.5435 8.88041 23.7116 9.13201 23.8263 9.40891C23.941 9.68582 24 9.9826 24 10.2823C24 10.582 23.941 10.8788 23.8263 11.1557C23.7116 11.4326 23.5435 11.6842 23.3315 11.8962L12.4381 22.7896L8 24L9.21038 19.5619L20.1038 8.66848Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditSmall);
export default __webpack_public_path__ + "static/media/icon_edit_small.e79c3e079518bb67d99200d229ca7e5e.svg";
export { ForwardRef as ReactComponent };